export default __webpack_public_path__ + "img/cqEDpGqQ.e9183eff.svg";